function DatalayerUsrSegment () {
	this.localStorageKey = 'usrSegment';
	this.ncwitSegment = 'NCWIT';
	this.noSegment = 'no segment';
	this.userSegmentCalls = 0;
}

DatalayerUsrSegment.prototype.init = function ( loggedIn = true ) {
	const usrSegment = window.localStorage.getItem( this.localStorageKey );

	if ( ! loggedIn ) {
		if ( usrSegment ) {
			window.localStorage.removeItem( this.localStorageKey );
		}
		this.dataLayerPush();
	} else if ( this.userSegmentCalls < 1 ) { // This is done to avoid multiple datalayer pushes
		if ( usrSegment ) {
			// Only push if user segment exists in local storage
			this.dataLayerPush( usrSegment );
		} else {
			// Call Piano API if no user segment in local storage
			this.callPianoApi();
		}

		this.userSegmentCalls ++;
	}
};

DatalayerUsrSegment.prototype.dataLayerPush = function ( usrSegment = '' ) {
	const dataLayerObject = {
		event: 'usr_segment_loaded',
	};

	// Add the user segment to the dataLayerObject if it is there.
	if ( usrSegment && this.noSegment !== usrSegment ) {
		dataLayerObject.usr_segment = usrSegment;
	}

	dataLayer.push( dataLayerObject );
};

DatalayerUsrSegment.prototype.callPianoApi = function () {
	try {
		tp.push( [ 'init', function () {
			tp.api.callApi( '/conversion/list', {}, function ( response ) {
				let hasAccess = false;

				if ( response && response.conversions && response.conversions.length ) {
					response.conversions.forEach( function ( item ) {
						// Check if segment is in the description of the terms for the user.
						if ( item.term.description && item.term.description.includes( this ) ) {
							hasAccess = true;
						}
					}.bind( this.ncwitSegment ) );
				}

				// Push dataLayer accordingly and add the segment to the local storage.
				if ( hasAccess ) {
					this.dataLayerPush( this.ncwitSegment );
					window.localStorage.setItem( this.localStorageKey, this.ncwitSegment );
				} else {
					this.dataLayerPush();
					window.localStorage.setItem( this.localStorageKey, this.noSegment );
				}
			}.bind( this ) );
		}.bind( this ) ] );
	} catch ( error ) {
		console.error( 'Piano API call failed:', error );
		// Send dataLayer push if the API fails. We won't save to localstorage to allow the api call to be made again on the next page.
		this.dataLayerPush();
	}
};

export default DatalayerUsrSegment;
